import { render, staticRenderFns } from "./questions.vue?vue&type=template&id=4c46d1bf"
import script from "./questions.vue?vue&type=script&scoped=true&lang=js"
export * from "./questions.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./questions.vue?vue&type=style&index=0&id=4c46d1bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports